import Splide from '@splidejs/splide'
import { BenQuery } from './BenQuery'
import { BenLoading } from './BenLoading'
import { BenModal } from './BenModal'

export class BenImageSlides {
  static init(dones, app) {
    const $sw = BenQuery.query(`[ben-js="image-slides"]`)
    $sw.forEach(($item) => {
      if (dones.includes($item)) return
      dones.push($item)
      $item.addEventListener('click', () => {
        _clickEvent($item, app)
      })
    })
  }
}

async function _clickEvent($dom: HTMLElement, app) {
  const dir = $dom.getAttribute('dir')
  const count = Number($dom.getAttribute('count'))
  if (!dir || !count) return
  const $splide = document.createElement('div')
  $splide.classList.add('g007')
  $splide.classList.add('splide')
  let slideHtml = ''
  for (let i = 0; i < count; i++) {
    slideHtml += `<div class="splide__slide"><img src="${dir}/${i + 1}-b.webp" /></div>`
  }
  $splide.innerHTML = `<div class="splide__track"><div class="splide__list">${slideHtml}</div></div>`
  BenModal.init($splide, app, { type: 'image' })
  await BenQuery.sleep(30)
  const direction = BenQuery.isRTL($dom) ? 'rtl' : 'ltr'
  const swObj = new Splide($splide, {
    direction,
    autoWidth: true,
    perPage: 1,
    focus: 'center',
    pagination: true,
    arrows: true,
  })
  swObj.mount()
}
